/**
 * §P.6 · El marco de «Avisos»: lo que el club dice y lo que se le dice.
 *
 * Cuatro pantallas que son las cuatro caras de hablar con las familias: el aviso que
 * se manda a muchos, la conversación con una, el muro que se llena solo y el horario
 * que decide cuándo puede sonar el móvil de alguien.
 *
 * El horario de silencio solo lo ven el dueño y el administrativo —sus dos rutas
 * declaran `own` y `adm`—, y tiene sentido: es una decisión del club sobre cuándo
 * interrumpe a sus familias, no de quien da clase.
 */
import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { vistasDeComunicacionPara } from '@/club/secciones';
import { useContextoDelClub } from '@/club/contexto';

export function MarcoDeComunicacion() {
  const camino = useRouterState({ select: (s) => s.location.pathname });
  const { rol } = useContextoDelClub();

  return (
    <>
      <nav className="pestañas" aria-label="Pantallas de comunicación">
        {vistasDeComunicacionPara(rol).map((v) => {
          const destino = `/avisos/${v.id}`;
          return (
            <Link
              key={v.id}
              to={destino}
              className={
                camino.startsWith(destino) ? 'pestaña-activa' : 'btn-plano'
              }
            >
              {v.etiqueta}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </>
  );
}
